import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "group relative h-full w-full [container-type:inline-size]" }
const _hoisted_2 = ["src", "title"]
const _hoisted_3 = {
  key: 0,
  class: "pointer-events-none absolute inset-x-0 bottom-0 flex min-h-[22%] items-end bg-[linear-gradient(to_top,rgba(0,0,0,0.78)_0%,rgba(0,0,0,0.42)_62%,rgba(0,0,0,0)_100%)] px-[3.5%] pb-[2.5%] pt-[8%] text-left text-[max(11px,5cqw)] font-semibold leading-[1.22] text-white [text-shadow:0_1px_2px_rgba(0,0,0,0.85)]"
}
const _hoisted_4 = { class: "line-clamp-2" }
const _hoisted_5 = {
  key: 1,
  class: "icon-img flex h-full w-full items-center justify-center bg-[radial-gradient(circle_at_top,_rgba(96,165,250,0.16),_transparent_60%)] text-slate-400 transition group-hover:text-slate-600"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_CropperModal = _resolveComponent("CropperModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: "#",
      class: "group flex h-full w-full items-center justify-center bg-slate-50/60 hover:bg-white",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showSearch && _ctx.showSearch(...args)), ["prevent"])),
      draggable: "true",
      onDragstart: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDragStart && _ctx.onDragStart(...args))),
      onDragover: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
      onDrop: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)))
    }, [
      (_ctx.currentImage)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("img", {
              src: _ctx.currentImage,
              title: _ctx.currentTitle,
              class: "h-full w-full object-cover"
            }, null, 8, _hoisted_2),
            (_ctx.showCaption)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.currentTitle), 1)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock("span", _hoisted_5, [
            _createVNode(_component_ion_icon, {
              class: "text-5xl",
              name: "images-outline"
            })
          ]))
    ], 32),
    (_ctx.canRecrop)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "absolute right-2 top-2 flex h-9 w-9 items-center justify-center rounded-xl border border-white/80 bg-white/90 text-slate-700 opacity-100 shadow-sm hover:text-blue-700 sm:opacity-0 sm:group-hover:opacity-100",
          "aria-label": "Adjust crop",
          onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openRecrop && _ctx.openRecrop(...args)), ["stop","prevent"]))
        }, [
          _createVNode(_component_ion_icon, { name: "crop-outline" })
        ]))
      : _createCommentVNode("", true),
    (_ctx.recropResult)
      ? (_openBlock(), _createBlock(_component_CropperModal, {
          key: 1,
          open: _ctx.recropOpen,
          result: _ctx.recropResult,
          onApplied: _ctx.applyRecrop,
          onClosed: _cache[5] || (_cache[5] = ($event: any) => (_ctx.recropOpen = false))
        }, null, 8, ["open", "result", "onApplied"]))
      : _createCommentVNode("", true)
  ]))
}